import { styled } from '@mui/material/styles';
import { Fab } from '@mui/material';

interface StyledFabProps {
  pulse?: boolean;
  position?: 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left';
  fixed?: boolean;
}

export const StyledFab = styled(Fab, {
  shouldForwardProp: (prop) => prop !== 'pulse' && prop !== 'position' && prop !== 'fixed',
})<StyledFabProps>(({ theme, pulse, position, fixed }) => {
  const getPositionStyles = () => {
    if (!fixed) return {};
    
    switch (position) {
      case 'bottom-right':
        return {
          position: 'fixed' as const,
          bottom: theme.spacing(2),
          right: theme.spacing(2),
        };
      case 'bottom-left':
        return {
          position: 'fixed' as const,
          bottom: theme.spacing(2),
          left: theme.spacing(2),
        };
      case 'top-right':
        return {
          position: 'fixed' as const,
          top: theme.spacing(2),
          right: theme.spacing(2),
        };
      case 'top-left':
        return {
          position: 'fixed' as const,
          top: theme.spacing(2),
          left: theme.spacing(2),
        };
      default:
        return {};
    }
  };

  return {
    boxShadow: theme.shadows[6],
    transition: theme.transitions.create([
      'transform',
      'box-shadow',
    ], {
      duration: theme.transitions.duration.short,
    }),
    
    '&:hover': {
      transform: 'scale(1.05)',
      boxShadow: theme.shadows[8],
    },
    
    ...(pulse && {
      animation: 'fab-pulse 2s infinite',
      
      '@keyframes fab-pulse': {
        '0%': {
          transform: 'scale(1)',
        },
        '50%': {
          transform: 'scale(1.1)',
        },
        '100%': {
          transform: 'scale(1)',
        },
      },
    }),
    
    ...getPositionStyles(),
  };
}); 